var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "text-center box" }, [
      _c("img", {
        staticClass: "img-fluid",
        staticStyle: {
          position: "absolute",
          top: "50%",
          left: "50%",
          "margin-right": "-50%",
          transform: "translate(-50%, -50%)",
          "box-shadow": "0px 4px 8px"
        },
        attrs: { src: "/static/img/maintenence/1.gif", alt: "" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0df28bd6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df28bd6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maintenance/Index.vue
// module id = 2384
// module chunks = 0